var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-swatch",class:_vm.active ? 'color-swatch--active' : '',on:{"click":function($event){return _vm.switchActiveColor()}}},[_c('div',{staticClass:"color-swatch__content",style:({ backgroundColor: _vm.color })})])
}
var staticRenderFns = []

export { render, staticRenderFns }